import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/works/__components/MetricsRow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/works/__components/WorksGrid.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/works/works.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/ui-utilities.scss");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
